import Echo from "laravel-echo";
import Pusher from "pusher-js";
import api from "@/lib/axios";

let echo: Echo<any> | null = null;

// Ensure Pusher is available globally
if (typeof window !== "undefined") {
  // @ts-ignore
  window.Pusher = Pusher;

  echo = new Echo({
    broadcaster: "pusher",
    key: process.env.NEXT_PUBLIC_PUSHER_APP_KEY,
    cluster: process.env.NEXT_PUBLIC_PUSHER_APP_CLUSTER,
    forceTLS: true,
    authEndpoint: process.env.NEXT_PUBLIC_API_HOST + "/broadcasting/auth",
    auth: {
      headers: {
        Accept: "application/json",
      },
    },
    authorizer: (channel: any) => ({
      authorize: (socketId: string, callback: Function) => {
        api
          .post(
            process.env.NEXT_PUBLIC_API_HOST + "/broadcasting/auth",
            {
              socket_id: socketId,
              channel_name: channel.name,
            },
            {
              withCredentials: true, // This will send all cookies
            }
          )
          .then((response) => {
            callback(false, response.data);
          })
          .catch((error) => {
            callback(true, error);
          });
      },
    }),
  });
}
export default echo;
